import Vue from 'vue';
import VueBreadcrumbs from 'vue2-dynamic-breadcrumbs';
import VueRouter from 'vue-router';
import EditorView from '@/views/EditorView.vue';
import ConfirmModal from '@/components/backoffice/ConfirmModal.vue';
import Home from '@/views/client/Home.vue';
import ProductView from '@/views/client/ProductView.vue';
import ProductListView from '@/views/client/ProductListView.vue';
import ProductListByCatView from '@/views/client/ProductListByCatView.vue';
import ProductDetailView from '@/views/client/ProductDetailView.vue';
import SellerView from '@/views/client/SellerView.vue';
import ArticleListView from '@/views/client/ArticleListView.vue';
import ArticleDetailView from '@/views/client/ArticleDetailView.vue';
import AboutView from '@/views/client/AboutView.vue';
import ContactView from '@/views/client/ContactView.vue';
import ClientView from '@/views/client/ClientView.vue';
import AdminView from '@/views/backoffice/AdminView.vue';
import LoginView from '@/views/backoffice/LoginView.vue';
import ProductCompareView from '@/views/client/ProductCompareView.vue';
import OrderView from '@/views/client/OrderView.vue';
import OrderConfirmView from '@/views/client/OrderConfirmView.vue';

Vue.use(VueBreadcrumbs);
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'ClientView',
    component: ClientView,
    children: [
      {
        path: '/',
        name: 'Home',
        components: {
          'client-view': Home,
        },
        meta: {
          breadcrumb: {
            label: 'breadcrumbs.home',
          },
        },
      },
      {
        path: '/products',
        name: 'Products',
        components: {
          'client-view': ProductView,
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
        children: [
          {
            path: '',
            name: 'ProductList',
            components: {
              'product-view': ProductListView,
            },
            meta: {
              breadcrumb: {
                label: 'breadcrumbs.products',
                parent: 'Home',
              },
            },
            scrollBehavior() {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve({ x: 0, y: 0 });
                }, 500);
              });
            },
          },
          {
            path: 'byCategories/:id',
            name: 'ProductListByCat',
            components: {
              'product-view': ProductListByCatView,
            },
            meta: {
              breadcrumb: {
                label: 'breadcrumbs.products',
                parent: 'Home',
              },
            },
            scrollBehavior() {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve({ x: 0, y: 0 });
                }, 500);
              });
            },
          },
          {
            path: ':id',
            name: 'ProductDetail',
            meta: {
              breadcrumb: {
                template: () => import('@/components/Breadcrumbs/ProductDetail.vue'),
                parent: 'ProductList',
              },
            },
            components: {
              'product-view': ProductDetailView,
            },
            scrollBehavior() {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve({ x: 0, y: 0 });
                }, 500);
              });
            },
          },
          {
            path: ':id/compare',
            name: 'ProductCompareView',
            props: true,
            meta: {
              breadcrumb: {
                template: () => import('@/components/Breadcrumbs/ProductDetail.vue'),
                parent: 'ProductDetail',
              },
            },
            components: {
              'product-view': ProductCompareView,
            },
            scrollBehavior() {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve({ x: 0, y: 0 });
                }, 500);
              });
            },
          },
          {
            path: ':id/seller',
            name: 'SellerView',
            meta: {
              breadcrumb: {
                label: 'breadcrumbs.seller',
                parent: 'ProductDetail',
              },
            },
            components: {
              'product-view': SellerView,
            },
            scrollBehavior() {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve({ x: 0, y: 0 });
                }, 500);
              });
            },
          },
        ],
      },
      {
        path: '/articles',
        name: 'ArticleList',
        components: {
          'client-view': ArticleListView,
        },
        meta: {
          requiresAuth: false,
          breadcrumb: {
            label: 'breadcrumbs.articles',
            parent: 'Home',
          },
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
      },
      {
        path: '/articles/:id',
        name: 'ArticleDetail',
        components: {
          'client-view': ArticleDetailView,
        },
        meta: {
          breadcrumb: {
            template: () => import('@/components/Breadcrumbs/ArticleDetail.vue'),
            parent: 'ArticleList',
          },
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
      },
      {
        path: '/about',
        name: 'About',
        components: {
          'client-view': AboutView,
        },
        meta: {
          breadcrumb: {
            label: 'breadcrumbs.about',
            parent: 'Home',
          },
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
      },
      {
        path: '/order',
        name: 'Order',
        components: {
          'client-view': OrderView,
        },
        meta: {
          breadcrumb: {
            label: 'breadcrumbs.about',
            parent: 'Home',
          },
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
      },
      {
        path: '/orderconfirm',
        name: 'OrderConfirm',
        components: {
          'client-view': OrderConfirmView,
        },
        meta: {
          breadcrumb: {
            label: 'breadcrumbs.about',
            parent: 'Home',
          },
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
      },
      {
        path: '/contact',
        name: 'Contact',
        components: {
          'client-view': ContactView,
        },
        meta: {
          breadcrumb: {
            label: 'breadcrumbs.contact',
            parent: 'Home',
          },
        },
        scrollBehavior() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 });
            }, 500);
          });
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'BackofficeLoginView',
    component: LoginView,
  },
  {
    path: '/backoffice',
    name: 'AdminView',
    component: AdminView,
    children: [
      {
        path: '',
        redirect: { name: 'BackofficeArticleList' },
      },
      {
        path: 'articles',
        name: 'BackofficeArticleList',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ArticleListView.vue'),
        },
        meta: {
          breadcrumb: {
            label: 'backoffice.breadcrumbs.articles',
          },
        },
      },
      {
        path: 'order',
        name: 'BackofficeOrder',
        meta: {
          breadcrumb: {
            parent: 'BackofficeArticleList',
            label: 'backoffice.breadcrumbs.articles.new',
          },
        },
      },
      {
        path: 'articles/new',
        name: 'BackofficeArticleAdd',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ArticleDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeArticleList',
            label: 'backoffice.breadcrumbs.articles.new',
          },
        },
      },
      {
        path: 'articles/:id',
        name: 'BackofficeArticleEdit',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ArticleDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeArticleList',
            label: 'backoffice.breadcrumbs.articles.edit',
          },
        },
      },
      {
        path: 'stores',
        name: 'BackofficeStoreList',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/StoreListView.vue'),
        },
        meta: {
          breadcrumb: {
            label: 'backoffice.breadcrumbs.stores',
          },
        },
      },
      {
        path: 'stores/new',
        name: 'BackofficeStoreAdd',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/StoreDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeStoreList',
            label: 'backoffice.breadcrumbs.stores.new',
          },
        },
      },
      {
        path: 'stores/:id',
        name: 'BackofficeStoreEdit',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/StoreDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeStoreList',
            label: 'backoffice.breadcrumbs.stores.edit',
          },
        },
      },
      {
        path: 'categories',
        name: 'BackofficeCategoryList',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/CategoryListView.vue'),
        },
        meta: {
          breadcrumb: {
            label: 'backoffice.breadcrumbs.categories',
          },
        },
      },
      {
        path: 'categories/new',
        name: 'BackofficeCategoryAdd',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/CategoryDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeCategoryList',
            label: 'backoffice.breadcrumbs.categories.new',
          },
        },
      },
      {
        path: 'categories/:id',
        name: 'BackofficeCategoryEdit',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/CategoryDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeCategoryList',
            label: 'backoffice.breadcrumbs.categories.edit',
          },
        },
      },
      {
        path: 'products',
        name: 'BackofficeProductList',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ProductListView.vue'),
        },
        meta: {
          breadcrumb: {
            label: 'backoffice.breadcrumbs.products',
          },
        },
      },
      {
        path: 'products/new',
        name: 'BackofficeProductAdd',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ProductDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeProductList',
            label: 'backoffice.breadcrumbs.products.new',
          },
        },
      },
      {
        path: 'products/:id',
        name: 'BackofficeProductEdit',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ProductDetailView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeStoreList',
            label: 'backoffice.breadcrumbs.products.edit',
          },
        },
      },
      {
        path: 'about',
        name: 'BackofficeAbout',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/AboutView.vue'),
        },
        meta: {
          breadcrumb: {
            label: 'backoffice.breadcrumbs.about',
          },
        },
      },
      {
        path: 'about/edit',
        name: 'BackofficeAboutEdit',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/AboutEditView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeAbout',
            label: 'backoffice.breadcrumbs.about.edit',
          },
        },
      },
      {
        path: 'contact',
        name: 'BackofficeContact',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ContactView.vue'),
        },
        meta: {
          breadcrumb: {
            label: 'backoffice.breadcrumbs.contact',
          },
        },
      },
      {
        path: 'contact/edit',
        name: 'BackofficeContactEdit',
        components: {
          'backoffice-view': () => import(/* webpackChunkName: "backoffice" */ '@/views/backoffice/ContactEditView.vue'),
        },
        meta: {
          breadcrumb: {
            parent: 'BackofficeContact',
            label: 'backoffice.breadcrumbs.contact.edit',
          },
        },
      },
    ],
  },
  {
    path: '/editor',
    name: 'Editor',
    component: EditorView,
  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: ConfirmModal,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
